import type { Reducer } from 'redux';
import type { SetCuttingHeightActions } from './actions';
import constants from './constants';
import type SetCuttingHeightRecord from './data/SetCuttingHeightRecord';
import { defaultCuttingHeightRecord } from './data/SetCuttingHeightRecord';

const reducer: Reducer<SetCuttingHeightRecord, SetCuttingHeightActions> = (
  state = defaultCuttingHeightRecord,
  action
) => {
  if (action.type === constants.TOGGLE_MODAL_VISIBLE) {
    return { ...state, isOpen: !state.isOpen };
  }
  return state;
};

export default reducer;
